import React from "react";
import ServicesPage from "./common/ServicesPage";
import { Heading } from "@chakra-ui/react";
const PostCleaning = () => {
  return (
    <div>
      <ServicesPage 
       title={
                <Heading
                  as="h1"
                  textAlign="center"                     // Center text
                  px={{ base: 4, md: 8 }}               // Responsive horizontal padding
                  fontSize={{ base: "xl", md: "2xl" }} // Responsive font size
                  className="services-title"
                >
Clean spaces start here. 
                </Heading>
              }

        image="/baner (1).png"
        description={
          <>
            <p>
              Our <strong>Post-Construction Cleaning Services</strong> ensure
              that your newly built or renovated property is spotless,
              comfortable, and ready for use. After construction or remodeling,
              sites often remain filled with dust, debris, and unwanted
              materials. Our trained cleaning specialists handle every detail—
              from removing construction dust to polishing surfaces—so you can
              move in with confidence.
            </p>

            <p style={{ marginTop: "1rem" }}>
              We go beyond standard cleaning by focusing on deep sanitization
              and attention to detail. Using professional-grade equipment and
              eco-friendly cleaning solutions, our team transforms your space
              into a safe, hygienic, and welcoming environment. Whether it’s a
              residential property, office, or large commercial project, we
              deliver results that exceed expectations.
            </p>

            <ul
              style={{
                marginTop: "1rem",
                paddingLeft: "1.2rem",
                // color: "#FF4D00",
              }}
            >
              <li> Dust and debris removal from all surfaces</li>
              <li> Deep cleaning of floors, windows, and fixtures</li>
              <li> Sanitization for a safe and healthy environment</li>
              <li> Eco-friendly cleaning practices</li>
              <li> Flexible scheduling for residential and commercial sites</li>
            </ul>

            <p style={{ marginTop: "1rem" }}>
              By choosing our post-construction cleaning, you ensure a smooth
              transition from construction chaos to a pristine, move-in ready
              space. We help create the perfect finishing touch for your project
              with professionalism and care.
            </p>

            <p style={{ marginTop: "1rem", fontWeight: "bold" }}>
  Our Expertise
</p>

            <ul
              style={{
                marginTop: "1rem",
                paddingLeft: "1.2rem",
                // color: "#FF4D00",
              }}
            >
              <li> High Rise Towers</li>
              <li> Commercial buildings</li>
              <li> Multi residential buildings</li>
              </ul>

          </>
        }
      />
    </div>
  );
};

export default PostCleaning;
